import { MappedImage } from "src/utils/fw"

const bg = "https://assets.swoogo.com/uploads/full/3049107-65296bcbac585.png"
const vid = "https://player.vimeo.com/video/874898992?h=eee615cdc0&amp;badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479&autoplay=1"
const button = "https://app.sli.do/event/3Mxamo57MBihiV9VQEQrKx"

const links = [
    {
        top: "80%",
        left: "35.7%",
        width: "28.6%",
        height: "5.4%",
        label: "button",
        href: button,
        target: "_blank"
    }
]

export default () => {
    return <MappedImage roomName="Welcome to Future" links={links} imageURL={bg}>
        <iframe src={vid} allowfullscreen style={{
            top: "27%",
            left: "21.7%",
            width: "56.3447%",
            height: "48.4%",
            position: "absolute",
            border: 0
        }} autoPlay allow="autoplay" />
    </MappedImage>
}